"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAssetMissing;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isAssetMissing(asset) {
  var _ref = asset || {},
      assetFiles = _ref.assetFiles;

  return assetFiles && (0, _lodash.default)(assetFiles, 'ORIGINAL.status') === 'MISSING';
}